import UnsavedChanges from '@/components/unsavedChanges/UnsavedChanges';
import { useSummaryStockLevelsBlocker } from '@/services/catalogue/stockLevels/useSummaryStockLevelsBlocker';
import { FunctionComponent } from 'react';

interface SummaryStockLevelsUnsavedChangesProps {
  unsavedChanges: boolean;
}

const SummaryStockLevelsUnsavedChanges: FunctionComponent<SummaryStockLevelsUnsavedChangesProps> = ({
  unsavedChanges = false
}) => {
  const blocker = useSummaryStockLevelsBlocker(unsavedChanges);

  return <UnsavedChanges show={blocker} />;
};

export default SummaryStockLevelsUnsavedChanges;
